import { postRequest } from "@react/helpers/fetch"

export const createDgd = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/dgd.json`, body: body })
